import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ApiEnvelope } from "@/pages/app/provider/billings/billing-types";
import { ProviderDetails } from "../types/provider-types";
import { getConfigObject } from "../utils/utils";
import { ProviderControllerApi } from "../services";

/**
 * @author Shrinivas Mandhare
 */

interface Params {
  providerUuid: string | null | undefined;
  tenantId?: string;
}
export const useProvider = ({
  providerUuid,
  tenantId,
}: Params): UseQueryResult<
  ApiEnvelope<ProviderDetails> | undefined,
  AxiosError
> =>
  useQuery({
    queryKey: ["provider", tenantId, providerUuid],
    enabled: !!providerUuid,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ProviderControllerApi(getConfigObject())
        .getProviderById(providerUuid ?? "", tenantId)
        .then((res) => res?.data as ApiEnvelope<ProviderDetails>),
  });
